import { getEnvironment } from "@/services/AmplifyConfigService.js";
import devSettings from "./appsettings-dev.json";
import qaSettings from "./appsettings-qa.json";
import prodSettings from "./appsettings-prod.json";

const envAppsettings = {
  dev: devSettings,
  qa: qaSettings,
  prod: prodSettings
};

const getSettings = () => {
  const env = getEnvironment();
  const settings = envAppsettings[env];

  if (settings == null || settings == undefined) return envAppsettings.prod;

  return settings;
};

const settings = getSettings();

export default settings;
